export default "__VITE_ASSET__CY3ZdHMt__"